import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import PreviewWrapper from '@/components/checkup/PreviewWrapper.vue'
import BackgroundPopup from '@/components/checkup/BackgroundPopup.vue'
import useTwilioBackground from '@/composables/twilio/useTwilioBackground'
import DeviceSettingPopup from '@/components/checkup/DeviceSettingPopup.vue'
import { setLocalTrackElement } from '@/helpers/twilio.helper'
import { createPreviewLocalTracks } from '@/helpers/twilio.helper'
import { useBackgroundStore, useDeviceStore } from '@/stores'
import { LocalTrack } from 'twilio-video'
import { onMounted, ref, watch, toRaw, computed, onUnmounted } from 'vue'
import { Engine } from '../../types/enums/room.enum'


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewTwilio',
  props: {
  canSetBackground: {
    type: Boolean,
    default: false,
  },
  isAutoState: {
    type: Boolean,
    default: false,
  },
  canOpenSetting: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

const popupOpened = ref<boolean>(false)
const settingPopupOpened = ref<boolean>(false)
const localTracks = ref<LocalTrack[]>([])
const localTrackRef = ref<HTMLVideoElement>()
const currentTab = ref<string>('quality')

const userMediaConstraints = computed(() => {
  return {
    audio: device.haveAudio ? { deviceId: device.maskSelectedAudio } : false,
    video: device.haveVideo
      ? {
          ...device.currentVideoQuality,
          deviceId: device.maskSelectedVideo,
        }
      : false,
  }
})
const device = useDeviceStore()
const background = useBackgroundStore()
const { setImageBackground, removeProcessor } = useTwilioBackground()

const setLocalTrack = () => {
  const option = {
    haveAudio: device.haveAudio,
    haveVideo: device.haveVideo,
    cameraOn: device.maskCameraOn,
    microphoneOn: device.maskMicrophoneOn,
    height: device.currentVideoQuality?.height,
    width: device.currentVideoQuality?.width,
  }
  setLocalTrackElement(
    { localTrackRef: localTrackRef.value, localTwilioTracks: toRaw(localTracks.value), option },
    (level) => {
      device.audioLevel = device.maskMicrophoneOn ? level : 0
    },
  )
  toRaw(localTracks.value).forEach((track) => {
    if (track.kind === 'video') {
      setImageBackground(track, background.currentBackground)
    }
  })
}

const init = async () => {
  if (localTracks.value.length) {
    toRaw(localTracks.value).forEach((track) => {
      if (track.kind === 'video') {
        track.stop()
      }
    })
    localTracks.value = []
  }
  localTracks.value = await createPreviewLocalTracks(userMediaConstraints.value)
  setLocalTrack()
}

const toggleCamera = async () => {
  if (props.isAutoState) {
    await device.toggleCamera(true)
  } else {
    device.maskCameraOn = !device.maskCameraOn
  }
  toRaw(localTracks.value).forEach((track) => {
    if (track.kind === 'video') {
      track.enable(device.maskCameraOn)
      if (track.isEnabled) {
        setImageBackground(track, background.currentBackground)
      } else {
        removeProcessor(track)
      }
    }
  })
}

const toggleMicrophone = async () => {
  if (props.isAutoState) {
    await device.toggleMicrophone(true)
  } else {
    device.maskMicrophoneOn = !device.maskMicrophoneOn
  }
  toRaw(localTracks.value).forEach((track) => {
    if (track.kind === 'audio') {
      track.enable(device.maskMicrophoneOn)
    }
  })
}

watch(
  () => userMediaConstraints.value,
  () => init(),
  { deep: true },
)

watch(
  () => [device.maskCameraOn, device.maskMicrophoneOn],
  () => setLocalTrack(),
  { deep: true },
)

onMounted(() => {
  init()
})
onUnmounted(() => {
  if (localTracks.value.length) {
    toRaw(localTracks.value).forEach((track) => {
      if (track.kind === 'video') {
        track.stop()
      }
    })
    localTracks.value = []
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PreviewWrapper, {
    "is-ready": _unref(device).isReady,
    "camera-enabled": _unref(device).maskCameraOn,
    "is-camera-found": _unref(device).haveVideo,
    "allowed-camera": _unref(device).allowedCamera,
    "microphone-enabled": _unref(device).maskMicrophoneOn,
    "is-microphone-found": _unref(device).haveAudio,
    "allowed-microphone": _unref(device).allowedMicrophone,
    "can-set-background": __props.canSetBackground && _unref(device).canChangeBackground,
    onToggleCamera: toggleCamera,
    onToggleMicrophone: toggleMicrophone,
    onOpenBackgroundSetting: _cache[3] || (_cache[3] = ($event: any) => (popupOpened.value = true)),
    onOpenSetting: _cache[4] || (_cache[4] = ($event: any) => (settingPopupOpened.value = true))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "localTrackRef",
        ref: localTrackRef,
        class: _normalizeClass(["video-track --me", [!_unref(device).maskCameraOn && 'video-display-none']])
      }, null, 2),
      _createVNode(BackgroundPopup, {
        modelValue: popupOpened.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((popupOpened).value = $event)),
        engine: _unref(Engine).TWILIO,
        onApplyBackground: init
      }, null, 8, ["modelValue", "engine"]),
      _createVNode(DeviceSettingPopup, {
        modelValue: settingPopupOpened.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((settingPopupOpened).value = $event)),
        currentTab: currentTab.value,
        "onUpdate:currentTab": _cache[2] || (_cache[2] = ($event: any) => ((currentTab).value = $event)),
        option: ['quality']
      }, null, 8, ["modelValue", "currentTab"])
    ]),
    _: 1
  }, 8, ["is-ready", "camera-enabled", "is-camera-found", "allowed-camera", "microphone-enabled", "is-microphone-found", "allowed-microphone", "can-set-background"]))
}
}

})